import {useEffect, useState} from 'react';
import projectUtils from "../../../../../../utils/project-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const UseSosSse = (data, isSuccess, eventId, chatRef, setTarget) => {
    const [event, setEvent] = useState();
    const [location, setLocation] = useState();
    const [aggressorLocation, setAggressorLocation] = useState(new Map());

    useEffect(() => {
        if (!isSuccess) return;

        setEvent(data);
        if (data.citizen?.aggressors) {
            const newMap = new Map();
            data.citizen?.aggressors.forEach((aggressor) => {
                if (aggressor.latitude !== null && aggressor.longitude !== null) {
                    newMap.set(aggressor.itemId, {latitude: aggressor.latitude, longitude: aggressor.longitude});
                }
            })

            setAggressorLocation(newMap);
        }

        if (data.dtEnd) {
            setLocation(data);
            return;
        }

        const source = new EventSource(`${API_KEEPER}/sos/event/${eventId}/subscribe`);

        source.addEventListener('event.location', e => {
            const location = JSON.parse(e.data)
            if (location?.target) {
                setTarget(location?.target)
            }

            setLocation(location);
        });

        source.addEventListener('event.ack', e => {
            setEvent(JSON.parse(e.data));
        });

        source.addEventListener('aggressor.location', e => {
            const data = JSON.parse(e.data);
            setAggressorLocation(prev => {
                const newMap = new Map(prev);
                newMap.set(data.itemId, data);

                return newMap;
            })
        });

        source.addEventListener('event.finalized', e => {
            setEvent(JSON.parse(e.data));
            if (chatRef.current) {
                chatRef.current?.close();
            }
        });

        source.onerror = e => {
            console.error('Error to load events.');
            console.error(e);

            projectUtils.swalErrorMessage("", "Falha ao obter localização")
        };

        return () => source.close();
    }, [data, isSuccess]);

    return { event, location, aggressorLocation, setAggressorLocation };
};

export default UseSosSse;